import React, { useEffect, useState } from 'react';
import './SubscriptionSuccess.css';

const SubscriptionSuccess = () => {
  const [showSuccess, setShowSuccess] = useState(false);
  const [showError, setShowError] = useState(false);

  useEffect(() => {
    // Check URL parameters
    const params = new URLSearchParams(window.location.search);
    const subscribed = params.get('subscribed');

    if (subscribed === 'success') {
      setShowSuccess(true);
      // Auto-hide after 8 seconds
      setTimeout(() => {
        setShowSuccess(false);
        // Clean URL
        window.history.replaceState({}, document.title, window.location.pathname);
      }, 8000);
    } else if (subscribed === 'error') {
      setShowError(true);
      setTimeout(() => {
        setShowError(false);
        window.history.replaceState({}, document.title, window.location.pathname);
      }, 8000);
    }
  }, []);

  if (!showSuccess && !showError) return null;

  return (
    <>
      {showSuccess && (
        <div className="subscription-banner success">
          <div className="subscription-banner-content">
            <div className="subscription-banner-icon">✅</div>
            <div className="subscription-banner-text">
              <h3>Email Confirmed!</h3>
              <p>You're now subscribed to Focus-View. Welcome aboard! 🎉</p>
            </div>
            <button 
              className="subscription-banner-close"
              onClick={() => setShowSuccess(false)}
            >
              ×
            </button>
          </div>
        </div>
      )}

      {showError && (
        <div className="subscription-banner error">
          <div className="subscription-banner-content">
            <div className="subscription-banner-icon">❌</div>
            <div className="subscription-banner-text">
              <h3>Confirmation Failed</h3>
              <p>The confirmation link is invalid or expired. Please try subscribing again.</p>
            </div>
            <button 
              className="subscription-banner-close"
              onClick={() => setShowError(false)}
            >
              ×
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default SubscriptionSuccess;
